import Snackbar from '@material-ui/core/Snackbar';
import {removeSnackbar} from 'Core/ducks/snackbar';
import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {Alert} from '@material-ui/lab';
import './Notifications.sass';
import {Link} from 'react-router-dom';

const Notifications = () => {
  const dispatch = useDispatch();

  const {messages} = useSelector((state: ReducerState) => state.snackbar);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  });

  const handleCloseCurried = (id: string) => (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);

    dispatch(removeSnackbar(id));
  };

  return (
    <>
      {messages.map(message => {
        const {useAlert, description, id, linkText = null, linkPath = null} = message;

        const handleClose = handleCloseCurried(id);

        const messageWithLink =
          linkText && linkPath ? (
            <>
              {description}{' '}
              <Link to={linkPath} style={{textDecoration: 'underline'}} onClick={handleClose}>
                {linkText}
              </Link>
            </>
          ) : (
            description
          );

        return useAlert! ? (
          <Snackbar
            key={`snackbar_${id}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={open}
            className={'snackbar-color-primary'}
            onClose={handleClose}
            message={messageWithLink}
          >
            <Alert
              icon={false}
              className={'snackbar-icon-default'}
              variant="outlined"
              severity="info"
              onClose={handleClose}
            >
              {messageWithLink}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={`snackbar_${id}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            className={'snackbar-color-primary'}
            open
            autoHideDuration={5 * 1000}
            onClose={() => dispatch(removeSnackbar(id))}
          >
            <Alert className={'snackbar-icon-default'} variant="outlined" severity="info">
              {messageWithLink}
            </Alert>
          </Snackbar>
        );
      })}
    </>
  );
};

export default Notifications;
